import { Card, CardContent, Stack, Box, Table, TableContainer, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import React, { useState } from "react";
import CardTitle from "./CardTitle";
import MiniField from "./MiniField";
import { useDispatch, useSelector } from "react-redux";
import { updateDataFilterSetting } from "../../reducer/CalcSettingsSlice";
import { DataFilterTypes, capitalizeFirstLetter, roundToX } from "../../common/common";

export default function FocusByPercentageCard(props) {
    const calcSettings = useSelector(state => state.calcSettings);
    const laserData = useSelector(state => state.laserData);
    const focusSetting = calcSettings.changes.dataFilters.find(df => df.type === DataFilterTypes.FocusByPercentage);
    const [minPointError, setMinPointError] = useState(false);
    const dispatch = useDispatch();

    const handleEliminatePointChange = (evt) => {
        if (evt.target.value.match(/^[0-9]*$/)) {
            evt.preventDefault();
            console.log(evt.target.value/100);
            let error = (evt.target.value.length === 0) || (Number(evt.target.value) === 0);
            setMinPointError(error);
            dispatch(updateDataFilterSetting({
                type: DataFilterTypes.FocusByPercentage,
                property: "EliminatePercent",
                value: String(evt.target.value / 100),
                error: error
            }));
        }
    }
    const handleMinPointChange = (evt) => {
        if (evt.target.value.match(/^[0-9]*$/)) {
            evt.preventDefault();
            console.log(evt.target.value/100);
            let error = (evt.target.value.length === 0) || (Number(evt.target.value) === 0);
            setMinPointError(error);
            dispatch(updateDataFilterSetting({
                type: DataFilterTypes.FocusByPercentage,
                property: "MinPointsPercent",
                value: String(evt.target.value / 100),
                error: error
            }));
        }
    }

    const renderTrace = (dataType) => {
        let filter = laserData.filterTrace.filters.find(f => f.type === "FocusByPercentage" && f.data === dataType);
        if(filter) {
            return (
                <Box 
                    sx={{width: "50%", fontSize:"13px", paddingTop: "5px"}}
                >
                    <label>{`${capitalizeFirstLetter(dataType)} - Initial Points: `}<b>{filter.trace.initialpointcount}</b></label>
                    <TableContainer 
                        sx={{height: "100px", overflow: 'auto', fontSize:"13px"}}
                    >
                        <Table
                            size="small"
                            stickyHeader
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="none" align="center" sx={{fontSize:"13px"}}>Pass</TableCell>
                                    <TableCell padding="none" align="center" sx={{fontSize:"13px"}}>Points Removed</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                { 
                                    filter.trace.iterations.map((step, index) => (
                                        <TableRow key={`tr-${index}-${dataType}`}>
                                            <TableCell padding="none" align="center" sx={{fontSize:"13px"}}>{step.iteration}</TableCell>
                                            <TableCell padding="none" align="center" sx={{fontSize:"13px"}}>{step.pointsremoved}</TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            )
        } else {
            return <></>
        }
    }

    const renderAttributes = () => {
        if(focusSetting) {
            return(
                <Stack>
                    <Box sx={{ display: "flex", gap: "8px", mb: "10px" }}>
                        <MiniField
                            label="Eliminate x% per iteration"
                            value={roundToX(focusSetting.attributes.EliminatePercent * 100, 0)}
                            onChange={handleEliminatePointChange}
                            maxLength={2}
                            error={minPointError}
                            disabled={!focusSetting.enabled}
                        />
                        <MiniField
                            label="Best x%"
                            value={roundToX(focusSetting.attributes.MinPointsPercent * 100, 0)}
                            onChange={handleMinPointChange}
                            maxLength={2}
                            error={minPointError}
                            disabled={!focusSetting.enabled}
                        />
                    </Box>
                    <Box>
                        <Stack direction="row" >
                            {renderTrace("machine")}
                            {renderTrace("motor")}
                        </Stack>
                    </Box>
                </Stack>
            );
        } else {
            return ("Not applied");
        }
    }

    return(
        <Card variant="outlined" >
            <CardContent >
                <CardTitle title="Focus By Percentage" />
                {renderAttributes()}
            </CardContent>
        </Card>
    )
}